// extracted by mini-css-extract-plugin
export default {"buttonContent":"AddToWatchList_buttonContent__JJM7S","buttonContentMobile":"AddToWatchList_buttonContentMobile__ErJfJ"};